export default __webpack_public_path__ + "locales/lv/JavascriptSdk.json?hash=1c464594311e9cd191c7df0d2e06a984";